import { AbstractService } from '@sol/components';

export type AsmEnvironment = 'dit' | 'local' | 'uat' | 'prod';

export interface AsmComponentsState {
  environment: AsmEnvironment;
  apiUrl: string;
  licenseServiceQueryUrl?: string;
  licenseServiceCommandUrl?: string;
  auditLogServiceQueryUrl?: string;
  customerApiUrl: string;
  smokeTestApiUrl: string;
  pendoApiKey: string;
  outscanUrl: string;
  scope?: string;
  subscopeId?: string;
  subscopeKey?: string;
}

export class AsmComponentsService extends AbstractService<AsmComponentsState> {
  constructor(
    private environmentName: AsmEnvironment,
    private apiUrl: string,
    private licenseServiceQueryUrl?: string,
    private licenseServiceCommandUrl?: string,
    private auditLogServiceQueryUrl?: string,
    customerApiUrl?: string,
    smokeTestApiUrl?: string,
    pendoApiKey?: string,
    outscanUrl?: string,
  ) {
    super({
      environment: environmentName,
      apiUrl: apiUrl,
      licenseServiceQueryUrl: licenseServiceQueryUrl,
      licenseServiceCommandUrl: licenseServiceCommandUrl,
      auditLogServiceQueryUrl: auditLogServiceQueryUrl,
      customerApiUrl: customerApiUrl ?? apiUrl,
      smokeTestApiUrl: smokeTestApiUrl ?? '',
      pendoApiKey: pendoApiKey ?? '',
      outscanUrl: outscanUrl ?? '',
    });
  }

  public setScopeHeader(scope?: string, subscopeId?: string, subscopeKey?: string): void {
    this.patch({
      scope: scope,
      subscopeId: subscopeId,
      subscopeKey: subscopeKey,
    });
  }

  public setSubscopeHeader(subscopeId?: string, subscopeKey?: string): void {
    this.patch({
      subscopeId: subscopeId,
      subscopeKey: subscopeKey,
    });
  }
}
